import styled, { css } from 'styled-components';

export const StyledButton = styled.button<{
  $variant: 'primary' | 'secondary' | 'danger' | 'link';
  $size: 'small' | 'medium' | 'large';
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-family-base);
  font-weight: 600;
  border: none;
  cursor: pointer;
  gap: var(--spacing-sm);
  transition: all var(--transition-fast);

  ${({ $size }) => {
    switch ($size) {
      case 'small':
        return css`
          padding: var(--spacing-xs) var(--spacing-md);
          font-size: var(--font-size-sm);
          border-radius: var(--radius-md);
        `;
      case 'large':
        return css`
          padding: var(--spacing-md) var(--spacing-lg);
          font-size: var(--font-size-lg);
          border-radius: calc(var(--radius-xl) * 2);
        `;
      default:
        return css`
          padding: var(--spacing-sm) var(--spacing-lg);
          font-size: var(--font-size-md);
          border-radius: var(--radius-xl);
        `;
    }
  }}

  ${({ $variant }) => {
    switch ($variant) {
      case 'secondary':
        return css`
          background-color: transparent;
          color: var(--color-primary);
          border: 2px solid var(--color-primary);

          &:hover {
            background-color: var(--color-primary-hover);
            color: var(--color-white);
          }
        `;
      case 'danger':
        return css`
          background-color: var(--color-danger);
          color: var(--color-white);

          &:hover {
            background-color: var(--color-danger-hover);
          }
        `;
      case 'link':
        return css`
          background-color: transparent;
          color: var(--color-primary);
          border: none;
        `;
      default:
        return css`
          background-color: var(--color-primary);
          color: var(--color-white);

          &:hover {
            background-color: var(--color-primary-hover);
          }
        `;
    }
  }}

  ${({ disabled }) =>
    disabled &&
    css`
      background-color: var(--color-border);
      color: var(--color-secondary);
      cursor: not-allowed;
      pointer-events: none;
    `}

  &:active {
    transform: scale(0.96);
  }
`;
